import { CodeNameEntity } from '../common/code-name-entity';

export class InterCompany {
    id: number;
    code: string;
    name: string;
    interCompanyEN: CodeNameEntity;
    state: any;

    constructor(id: number, code: string, name: string, interCompanyEN: CodeNameEntity) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.interCompanyEN = interCompanyEN;
    }
}
